import storage from 'shared/helpers/storage';

// defs
import { Coupon } from './types';

const COUPON_APPLIED = 'COUPON_APPLIED';

export const toXDecimal = (value = 0, n = 1) => {
  if (value === null || value === 0) return value;

  return parseFloat(value.toFixed(n));
};

export const couponCodeAppliedOnCouponsPage = () => {
  storage.setItem(COUPON_APPLIED, true);
};

export const getCouponCodes = (coupons: Coupon[]) => {
  return coupons.map((coupon) => coupon.couponCode);
};
